const messagingCampaign = '/api/messaging-campaign'

export { messagingCampaign }
